<template lang="pug">
  .activity-wrapper
    h2 atividade

    .add-edit-activity(v-if="!showCreateEdit")
      .buttons
        PButton(color="primary" size="md" @click="genReport") gerar relatório
        PButton(color="warning" size="md" @click="addOredit({})") criar nova atividade

    .add-edit-activity(v-else)
      .input-grid
        .activityName
          PTextField(v-model="activity.activityName", label="nome" name="activityName")

        .name
          PSelect(v-model="activity.activityType" labelItem="name" title="tipo de atividade")

        .centro-custo
          PSelect(v-model="activity.activityCostCenter" labelItem="code" title="centro de custo")

        .duration
          PTimeField(v-model="activity.duration" label="duração" :baseDate="new Date()")

        .actived
          PCheckbox(label="Esta atividade está ativa?" v-model="activity.active")

        .company
          PMultiSelect(v-model="activity.companies" useCommon="companies/onlyActive" labelItem="name" :title="$wp('company')")

        .employee
          PMultiSelect(v-model="activity.employees" useCommon="employees" labelItem="name" :title="$wp('employee')")
        .group
          PMultiSelect(v-model="activity.userGroups" useCommon="userGroups" labelItem="name" title="grupos")

        .buttons
          PButton(color="success" size="md" block @click="save" :loading="saving")
            | {{ activity.id ? 'salvar' : 'criar' }}
          PButton(color="danger" size="md" block @click="close") cancelar

    SmartTable.table(
      name="activity-list"
      v-bind="table"
      v-model="tableData"
      ref="table"
      @rowClick="onSelectedActivity"
    )
      template(v-slot:default="slotProps")
        TableRow(v-bind="slotProps")
          template(v-slot:active="{ columnValue, rowItem, index }")
            .active
              .icon.fs-19.icon-ptt-icons-check.color-success(v-if="columnValue === true")
              .icon.fs-19.icon-ptt-icons-X.color-danger(v-else)
          template(v-slot:activityName="{ columnValue, rowItem, index }")
            span.no-wrap(:title="columnValue") {{ columnValue }}
          template(v-slot:activityCostCenter.code="{ columnValue, rowItem, index }")
            span.no-wrap(:title="columnValue")  {{ columnValue }}
          template(v-slot:activityType.name="{ columnValue, rowItem, index }")
            span.no-wrap(:title="columnValue") {{ columnValue }}
          template(v-slot:duration="{ columnValue, rowItem, index }")
            | {{ columnValue | floatToHoursMinsString }}

      template(v-slot:detailsBox="{item}")
        ActivityDetails(
          :item="activityInfoPerId[item.id]"
          :loading="loadingSelectedActivityInfo"
          :addOredit="addOredit"
          :deleteActivityType="deleteActivityType"
        )

</template>

<script>
import {floatToHoursMins, floatToHoursMinsString, hoursMinsToFloat} from 'src/utils'
import moment from 'moment'
import ActivityDetails from './ActivityDetails'

function defaultActivityData () {
  return {
    id: null,
    name: '',
    activityName: '',
    active: true,
    duration: null,
    activityType: {selected: null, loaded: [], loading: false},
    activityCostCenter: {selected: null, loaded: [], loading: false},
    companies: {selected: []},
    employers: {selected: []},
    routines: {selected: []},
    userGroups: {selected: []},
    employees: {selected: []}
  }
}

export default {
  name: 'ActivityType',
  async created () {
    this.getData()
  },
  data () {
    return {
      showCreateEdit: false,
      saving: false,
      data: [],
      loading: false,
      activity: defaultActivityData(),
      activityInfoPerId: {},
      loadingSelectedActivityInfo: false,
      table: {
        headerItems: [
          {
            column: 'status',
            field: 'active',
            width: '0.4fr',
            options: [
              {iconClass: 'icon-ptt-icons-check', text: 'Todos'},
              {iconClass: 'icon-ptt-icons-check', text: 'Ativo'},
              {iconClass: 'icon-ptt-icons-X', text: 'Inativo'}
            ],
            filterFunction: ({search, item}) => {
              if (search === 'Todos') return true

              return search === 'Ativo' ? item.active === true : !item.active
            }
          },
          {column: 'nome da atividade', field: 'activityName', width: '1fr'},
          {column: 'tipo de atividade', field: 'activityType.name', width: '1fr'},
          {column: 'centro de custo', field: 'activityCostCenter.code', width: '1fr'},
          {column: 'duração', field: 'duration', width: '1fr'}
        ],
        config: {
          perPage: 10,
          startFocusedSearch: 'activityName',
          defaultSortField: 'activityName',
          defaultColumnSearch: 'activityName',
          defaultFilterText: {field: 'active', text: 'Ativo'},
          detailsBox: {
            numberColumnsKeep: 3
          }
        }
      }
    }
  },
  computed: {
    tableData: {
      get () {
        return {
          loading: this.loading,
          loaded: this.data
        }
      },
      set () {}
    }
  },
  methods: {
    async getData () {
      this.loading = true
      const result = await this.$API.activity.get({
        fields: JSON.stringify(['id', 'name', 'activity_cost_center', 'activity_type', 'duration', 'active']),
        force: true})
      if (result.status === 200) {
        this.data = result.data.success
      }
      this.loading = false
    },
    addOredit (
      {
        id = null, name = '', active = true, activityName = '', duration = null, groups = null, employers = null,
        companies = null, routines = null, employees = null, activityCostCenter = null, activityType = null
      }
    ) {
      this.getActivityType()
      this.getCostCenters()

      this.showCreateEdit = true
      this.activity.id = id
      this.activity.name = name
      this.activity.activityName = activityName
      this.activity.active = active

      this.activity.activityCostCenter.selected = activityCostCenter
      this.activity.activityType.selected = activityType

      this.activity.userGroups.selected = groups || []
      this.activity.employers.selected = employers || []
      this.activity.companies.selected = companies || []
      this.activity.routines.selected = routines || []
      this.activity.employees.selected = employees || []
      this.activity.duration = duration
        ? moment().set(floatToHoursMins(duration)).toDate()
        : moment().set({hours: 2, minutes: 0}).toDate()
    },
    async deleteActivityType (id) {
      try {
        await this.$API.activity.delete({id})
        this.$swal({
          type: 'success',
          text: 'Deletada com sucesso!'
        })
        this.getData()
      } catch (e) {
        this.$swal({
          type: 'error',
          text: e?.data?.error ? e.data.error : 'Nâo foi possível deletar esse tipo de atividade'
        })
      }
      this.close()
    },
    close () {
      this.closeDetailsBox()
      this.showCreateEdit = false
      this.activity = defaultActivityData()
    },
    closeDetailsBox () {
      this.$refs.table.closeDetailsBox()
    },
    async save () {
      this.saving = true

      // remove cache
      this.activityInfoPerId[this.activity.id] = undefined

      try {
        await this.$API.activity.save(
          {id: this.activity.id},
          {
            activityName: this.activity.activityName,
            active: this.activity.active,
            activityCostCenter: this.activity.activityCostCenter.selected.id,
            activityType: this.activity.activityType.selected.id,
            companies: this.activity.companies.selected.map(i => i.id),
            employers: this.activity.employers.selected.map(i => i.id),
            employees: this.activity.employees.selected.map(i => i.id),
            groups: this.activity.userGroups.selected.map(i => i.id),
            routines: this.activity.routines.selected.map(i => i.id),
            funct: [],
            duration: hoursMinsToFloat(
              moment(this.activity.duration).hours(), moment(this.activity.duration).minutes()
            ),
            id: this.activity.id
          }
        )

        this.getData()
      } catch (e) {
        this.$swal({
          type: 'error',
          text: e?.data?.error ? e.data.error : 'Nâo foi possível realizar essa operação'
        })
      }

      this.saving = false
      this.close()
    },
    async getActivityType () {
      this.activity.activityType.loading = true
      const activityTypes = await this.$API.activityType.get()
      this.activity.activityType.loaded = activityTypes.data.success
      this.activity.activityType.loading = false
    },
    async getCostCenters () {
      this.activity.activityCostCenter.loading = true
      const activityCostCenters = await this.$API.activityCostCenter.get()
      this.activity.activityCostCenter.loaded = activityCostCenters.data.success
      this.activity.activityCostCenter.loading = false
    },
    async onSelectedActivity (activity) {
      if (!this.activityInfoPerId[activity.id]) {
        this.$set(this.activityInfoPerId, activity.id, {...activity})

        this.loadingSelectedActivityInfo = true

        const completeInfo = await this.$API.activity.get({
          id: activity.id,
          fields: JSON.stringify([
            'id',
            'name',
            'activity_cost_center',
            'activity_type',
            'duration',
            'active',
            'employees',
            'companies',
            'employers',
            'groups'
          ]),
          force: true
        })

        this.$set(this.activityInfoPerId, activity.id, completeInfo.data.success[0])

        this.loadingSelectedActivityInfo = false
      }
    },
    async genReport () {
      let result
      try {
        result = await this.$API.activityReport.get()
        this.$modalDeSucesso(result.data.success)
      } catch (e) {
        console.error(e)
        this.$modalDeErro(e?.data?.error ? e.data.error : 'Não foi possível gerar o relatório')
      }
    }
  },
  filters: {floatToHoursMinsString},
  components: {ActivityDetails}
}
</script>

<style scoped lang="scss">
.activity-wrapper {
  h2 {
    text-align: center;
  }

  .add-edit-activity {
    grid-row: 2;
    display: grid;

    .buttons {
      justify-self: end;
      margin-bottom: var(--header-margin-bottom);
    }

    .input-grid {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
      grid-column-gap: 30px;
      grid-row-gap: 30px;
      grid-template-areas:
        "activityName name name centro-custo duration"
        "employee company group actived buttons";

      .activityName {grid-area: activityName}
      .name {grid-area: name;}
      .centro-custo { grid-area: centro-custo }
      .duration { grid-area: duration }
      .actived {
        grid-area: actived;
        margin-top: 10%
      }
      .employee { grid-area: employee }
      .group { grid-area: group }
      .company { grid-area: company }

      .buttons {
        grid-area: buttons;
        justify-items: end;
        align-items: center;
        display: flex;
      }
    }
  }
}
</style>
